<script>
import appConfig from '@/app.config';
import { mapActions } from 'vuex';
// import { mapActions } from 'vuex';

// import { notificationMethods } from '@/state/helpers';

export default {
  name: 'app',
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      console.log(window.location.href, 'href ');
      let path_url = window.location.href
        ? window.location.href.replaceAll('-', ' ').split('/')
        : [];

      let alias = {
        opr: 'Operational',
        loc: 'Logistic',
        fin: 'Finance',
        conf: 'Setting',
      };

      if (path_url && path_url.length) {
        if (path_url.length < 7) {
          let module = path_url[path_url.length - 2];
          let full_module = alias[module] ? alias[module] : '';

          let path_url_last = path_url[path_url.length - 1];
          path_url_last.split(' ');
          let new_name = '';

          path_url_last.split(' ').forEach((element) => {
            new_name +=
              element.charAt(0).toUpperCase() + element.slice(1) + ' ';
          });

          if (full_module) {
            return new_name + '| ' + full_module;
          } else {
            title = typeof title === 'function' ? title(this.$store) : title;
            return title ? `${title} | ${appConfig.title}` : appConfig.title;
          }
        } else {
          let module = path_url[path_url.length - 3];
          let full_module = alias[module] ? alias[module] : '';

          let path_url_last = path_url[path_url.length - 1];
          let new_name = '';

          path_url_last.split(' ').forEach((element) => {
            new_name +=
              element.charAt(0).toUpperCase() + element.slice(1) + ' ';
          });

          if (full_module) {
            return (
              new_name +
              ' - ' +
              path_url[path_url.length - 2].charAt(0).toUpperCase() +
              path_url[path_url.length - 2].slice(1) +
              ' | ' +
              full_module
            );
          } else {
            title = typeof title === 'function' ? title(this.$store) : title;
            return title ? `${title} | ${appConfig.title}` : appConfig.title;
          }
        }
      }

      // if (title && typeof title !== 'function') {
      //   if (['Operational', 'Finance', 'Logistic', 'Setting'].includes(title)) {
      //     return `${title} | ${appConfig.title}`;
      //   }
      // }
    },
  },
  async created() {
    // document.querySelector("html").setAttribute('dir', 'rtl')
    // console.log('call user info ...');
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      // this.clearNotification();
    },
  },
  methods: {
    // clearNotification: notificationMethods.clear,
    ...mapActions('auth', ['getUserInfo']),
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
